// extracted by mini-css-extract-plugin
export var active = "_am-a";
export var activeIndicator = "_am-8";
export var animate = "_am-9";
export var disabled = "_am-b";
export var fullWidth = "_am-2";
export var lg = "_am-7";
export var md = "_am-6";
export var redoButtonTabGroup = "_am-0";
export var sm = "_am-5";
export var tabButton = "_am-3";
export var tabButtonsContainer = "_am-1";
export var xs = "_am-4";